import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, select, Action } from '@ngrx/store';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import { ReadDeviceChangeHistoryInfo } from '../change-info.model';
import { concatMap, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { EMPTY, Observable } from 'rxjs';
import { ChangeInfoActionTypes, ChangeInfoActions } from '../actions/change-info.actions';
import { ChangeInfoService } from '../../../services/change-info.service';

@Injectable()
export class ChangeInfoEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private changeInfoService = inject(ChangeInfoService);

  constructor() {}

  readDeviceChangeHistory$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.ChangeInfoActionTypes.GET_CHANGE_INFO),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
     const param: ReadDeviceChangeHistoryInfo = {
        otp: user.otp
     };
      return this.changeInfoService.ReadDeviceChangeHistory(param).pipe(
       map((res: any) => {
          if (res.result) {
            return new featureActions.GetChangeInfosSuccessAction(res.msg.body);
         } else {
            return  new featureActions.GetChangeInfosFailAction();
          }
       })
      );
   })
  ));
}
